import { TAJ_REGEX } from '../../../../../shared/regular-expressions/regex';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IDevice, DeviceStatusKind } from '@ahryman40k/ts-fhir-types/lib/R4';
import { FormControl, Validators, FormGroup } from '@angular/forms';

@Component({
  selector: 'inc-device-status',
  templateUrl: './device-status.component.html',
  styleUrls: ['./device-status.component.scss'],
})
export class DeviceStatusComponent implements OnInit {
  @Input() device: IDevice;
  @Output() callUpdate = new EventEmitter<any>();

  deviceStKin = DeviceStatusKind;
  statusForm: FormGroup;

  constructor() { }

  ngOnInit() { this.reset(); }

  reset() {
    this.statusForm = new FormGroup({
      taj: new FormControl('', [Validators.required, Validators.pattern(TAJ_REGEX)]),
      name: new FormControl(''),
      comment: new FormControl('')
    });
  }

  update(status: string, statusValue?: any) {
    this.callUpdate.emit({ device: this.device, statusValue, status });
    this.reset();
  }

  /* setupFormValidityBy(taj: string) {
    if (this.tajCtrl.valid) {
      PatientApi.getPatientByTAJ(taj).subscribe({
        next: (patient: Patient) => this.associatedPatWithEnteredTAJ = patient,
        error: () => { this.associatedPatWithEnteredTAJ = undefined; this.tajCtrl.setErrors({ patientDoesntExist: true }); }
      });
    } else {
      this.associatedPatWithEnteredTAJ = undefined;
      this.tajCtrl.setErrors({ patientDoesntExist: null });
    }
  }

  */

}
